import { StateInterface } from "./state";
import { GlobalInterface } from "../index.js";
import { GetterTree } from "vuex";
import Playlist from "@/classes/Playlist";
import Media from "@/classes/Media";
import ContentGroup from "@/classes/ContentGroup";

const getters: GetterTree<StateInterface, GlobalInterface> = {
	/**
	 * @returns all media files
	 */
	allMediaFiles: (state) => state.mediaFiles,
	/**
	 * @returns filtered content by names and the given search query
	 */
	filteredContent: (state) => (searchQuery: string) => {
		const result = state.mediaFiles.filter(function (content) {
			let regex = new RegExp("(" + searchQuery + ")", "i");

			if (content.name) {
				return content.name.match(regex);
			} else {
				if (content instanceof ContentGroup) {
					for (let index = 0; index < content.contentGroup.length; index++) {
						const subcontent = content.contentGroup[index];
						if (subcontent.name.includes(searchQuery) || searchQuery === "") {
							return content;
						} else if (content.contentGroup.length === index - 1) {
							return null;
						}
					}
				}
			}
		});
		return result;
	},
	/**
	 * @returns all media files of the given playlist
	 */
	getMediaFilesForPlaylist: (state) => (pl: Playlist) => {
		let result: (Media | ContentGroup | undefined)[] = [];
		pl.contentIds.forEach((contentId) => {
			result.push(
				state.mediaFiles.find((file) => {
					if (file.contentGroupId) {
						return file.contentGroupId === contentId;
					} else {
						return file.id === contentId;
					}
				})
			);
		});
		//console.log(result);
		return result;
	},

	// Function is needed at editMediaModal, to get next or previous content of all contents.
	// This enables the functionality of the left / right arrows
	/**
	* @returns next or previous content
	*/
	getNextContent: (state) => (currentContent: Media | ContentGroup, prev: boolean) => {
		const index = state.mediaFiles.findIndex((element) => {
			if (currentContent.contentGroupId) {
				return element.contentGroupId === currentContent.contentGroupId;
			} else {
				return element.id === currentContent.id;
			}
		});
		if (prev && index > 0) {
			return state.mediaFiles[index - 1];
		} else if (prev && index === 0) {
			return state.mediaFiles[state.mediaFiles.length - 1];
		} else {
			if (index === state.mediaFiles.length - 1) {
				return state.mediaFiles[0];
			} else {
				return state.mediaFiles[index + 1];
			}
		}
	}
};

export default getters;
